import type { ReactNode } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Renders its children on the web and nowhere else.
 *
 * Built for the "Download on the App Store" buttons, which appear on four
 * screens. Inside the installed app they invite the user to download the app
 * they are already using, and App Review treats a link out to the store as a
 * dead end.
 *
 * A component rather than a repeated `!Capacitor.isNativePlatform() &&` because
 * the first pass at this guarded only the login screen and left the other three
 * showing — the kind of miss a named wrapper makes visible in a grep.
 *
 * Not for anything security-relevant: it is a presentation choice, and the
 * platform check is trivially observable.
 */
export function WebOnly({ children }: { children: ReactNode }) {
  if (Capacitor.isNativePlatform()) return null;
  return <>{children}</>;
}
